export default __webpack_public_path__ + "static/media/generale.329f610b.svg";